"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getStaleDocs = getStaleDocs;
const getState_1 = require("./getState");
const dist_1 = require("../../core/dist");
/**
 * List documents that may be stale, via the single canonical `staleEntries`
 * predicate (core) — the same one `getState` attaches to each thread for the VS
 * Code tree, so `loom stale` and the extension always agree. A doc flagged for
 * more than one reason is listed once with its reasons joined.
 *
 * Single source of truth for staleness listing: both the `loom_get_stale_docs`
 * MCP tool and the `loom stale` CLI command call this use-case. By default only
 * actionable entries (not on done/cancelled/closed docs) are returned; pass
 * `includeDone` for the full historical view (`loom stale --all`).
 */
async function getStaleDocs(deps, opts) {
    const state = await (0, getState_1.getState)(deps);
    const includeDone = opts?.includeDone ?? false;
    // Title lookup across every doc (weave-level and thread-level).
    const docById = new Map();
    for (const weave of state.weaves) {
        for (const doc of weave.allDocs)
            docById.set(doc.id, doc);
        for (const thread of weave.threads) {
            for (const doc of thread.allDocs)
                docById.set(doc.id, doc);
        }
    }
    // Group entries by doc so a doc stale for >1 reason is listed once (stable count).
    const byDoc = new Map();
    for (const weave of state.weaves) {
        for (const e of (0, dist_1.staleEntries)(weave)) {
            if (!includeDone && !e.actionable)
                continue;
            const reasonText = `${e.reason}: ${e.detail}`;
            const existing = byDoc.get(e.docId);
            if (existing) {
                existing.reasons.push(reasonText);
            }
            else {
                byDoc.set(e.docId, { id: e.docId, type: e.type, weaveId: e.weaveId, threadId: e.threadId, reasons: [reasonText] });
            }
        }
    }
    return [...byDoc.values()].map(g => ({
        id: g.id,
        type: g.type,
        title: docById.get(g.id)?.title ?? g.id,
        weaveId: g.weaveId,
        threadId: g.threadId,
        reason: g.reasons.join('; '),
    }));
}
